import $x from '@/utils/$x';

/**
+ * 商家管理--概览
+ * @param {*} params
+ * @returns
+ */
export async function athenaOverview(params) {
  return $x.post('/athena/overview', params);
}

/**
+ * 商家管理--列表
+ * @param {*} params
+ * @returns
+ */
export async function athenaList(params) {
  return $x.post('/athena/list', params);
}

/**
+ * 商家管理--商家信息
+ * @param {*} params
+ * @returns
+ */
export async function athenaGetTenantInfo(params) {
  return $x.post('/athena/getTenantInfo', params);
}

/**
+ * 商家详情--商家信息--修改商家特征和诉求
+ * @param {*} params
+ * @returns
+ */
export async function modifyTenantInfo(params) {
  return $x.post('/athena/modifyTenantInfo', params);
}

/**
+ * 商家详情--修改商家第三方账号信息
+ * @param {*} params
+ * @returns
+ */
export async function modifyTenantThirdInfo(params) {
  return $x.post('/athena/modifyTenantThirdInfo', params);
}
/**
+ * 商家详情--获取企业信息
+ * @param {*} params
+ * @returns
+ */
export async function getEnterprise(params) {
  return $x.post('/athena/getEnterprise', params);
}
/**
+ * 商家详情--企业认证
+ * @param {*} params
+ * @returns
+ */
export async function enterpriseVerification(params) {
  return $x.post('/athena/enterpriseVerification', params);
}
/**
+ * 商家详情--修改商家信息
+ * @param {*} params
+ * @returns
+ */
export async function modifyEnterpriseInfo(params) {
  return $x.post('/athena/modifyEnterpriseInfo', params);
}
/**
+ *  GMV趋势接口
+ * @param {*} params
+ * @returns
+ */
export async function gmvTendencyChart(params) {
  return $x.post('/athena/gmvTendencyChart', params);
}

/**
+ * 商家详情--基础标签
+ * @param {*} params
+ * @returns
+ */
export async function getBaseTag(params) {
  return $x.post('/athena/getBaseTag', params);
}

/**
+ * 商家详情--用户构成
+ * @param {*} params
+ * @returns
+ */
export async function getUserStructure(params) {
  return $x.post('/athena/getUserStructure', params);
}

/**
+ * 商家详情--用户构成
+ * @param {*} params
+ * @returns
+ */
export async function getUserGrowth(params) {
  return $x.post('/athena/userGrowth', params);
}

/**
+ * 商家详情--用户明细
+ * @param {*} params
+ * @returns
+ */
export async function getUserDetail(params) {
  return $x.post('/athena/userDetail', params);
}

/**
+ * 商家详情--上课数据
+ * @param {*} params
+ * @returns
+ */
export async function userClassView(params) {
  return $x.post('/athena/userClassView', params);
}

/**
+ * 商家详情--课程计划
+ * @param {*} params
+ * @returns
+ */
export async function userClassPlan(params) {
  return $x.post('/athena/userClassPlan', params);
}

/**
+ * 商家详情--上课课表
+ * @param {*} params
+ * @returns
+ */
export async function getUserClass(params) {
  return $x.post('/athena/userClass', params);
}

/**
 * 保存和更新UniappSDK 包文件配置信息
 * @param {*} params
 * @returns
 */
export async function savePkg(params) {
  return $x.post('/pkg/savePkg', params);
}

/**
 * 商家详情--教练雷达图
 * @param {*} params
 * @returns
 */
export async function getTenantRadar(params) {
  return $x.post('/athena/tenantRadar', params);
}

/**
 * 商家详情--教练明细
 * @param {*} params
 * @returns
 */
export async function getCoachDetail(params) {
  return $x.post('/athena/coachDetail', params);
}

/**
 * 商家详情--教练信息
 * @param {*} params
 * @returns
 */
export async function getCoachInfo(params) {
  return $x.post('/athena/getCoachInfo', params);
}
/**
 * 商家详情--门店信息
 * @param {*} params
 * @returns
 */
export async function getTenantStoreInfo(params) {
  return $x.post('/athena/getTenantStoreInfo', params);
}
/**
 * 商家详情--商家推广素材信息
 * @param {*} params
 * @returns
 */
export async function materialInfo(params) {
  return $x.post('/athena/materialInfo', params);
}
/**
 * 商家详情--保存商家推广素材信息
 * @param {*} params
 * @returns
 */
export async function saveMaterialInfo(params) {
  return $x.post('/athena/saveMaterialInfo', params);
}

/**
 * 商家详情--特色课程
 * @param {*} params
 * @returns
 */
export async function getListTenantSpecialCourse(params) {
  return $x.post('/athena/listTenantSpecialCourse', params);
}

/**
 * 商家详情--专属计划
 * @param {*} params
 * @returns
 */
export async function getListTenantPlan(params) {
  return $x.post('/athena/listTenantPlan', params);
}

/**
 * 教练档案--商家教练列表 ID：wXPEW0rz
 * @param {*} params
 * @returns
 */
export async function listCoach(params) {
  return $x.post('/archive/listCoach', params);
}

/**
 * 教练档案--查看 ID：7zLpMGmz
 * @param {*} params
 * @returns
 */
export async function getCoachArchive(params) {
  return $x.post('/archive/getCoachArchive', params);
}

/**
 * 教练档案--保存&修改
 * @param {*} params
 * @returns
 */
export async function saveOrUpdate(params) {
  return $x.post('/archive/saveOrUpdate', params);
}

/**
 * 教练档案--企业微信员工列表
 * @param {*} params
 * @returns
 */
export async function listWxEmployees(params) {
  return $x.post('/archive/listWxEmployees', params);
}

/**
 * 教练档案--赛道划分
 * @param {*} params
 * @returns
 */
export async function track(params) {
  return $x.post('/archive/track', params);
}

/**
 * 教练档案--获客方式
 * @param {*} params
 * @returns
 */
export async function customerMode(params) {
  return $x.post('/archive/customerMode', params);
}

/**
 * 教练档案--培训进度 ID：d8xmm76X
 * @param {*} params
 * @returns
 */
export async function training(params) {
  return $x.post('/archive/training', params);
}

/**
 * 获取UniappSDK 包文件配置信息
 * @param {*} params
 * @returns
 */
export async function getPkg(params) {
  return $x.post('/pkg/getPkg', params);
}

/**
 * 订单权益
 * @param {*} params
 * @returns
 */
export async function listRights(params) {
  return $x.post('/athena/listRights', params);
}

/**
 * 商家GMV大盘
 * @param {*} params
 * @returns
 */
export async function gmv(params) {
  return $x.post('/athena/gmv', params);
}

/**
 * 商家GMV看板
 * @param {*} params
 * @returns
 */
export async function tenantGmv(params) {
  return $x.post('/athena/tenantGmv', params);
}

/**
 * 会员订单
 * @param {*} params
 * @returns
 */
export async function settlementList(params) {
  return $x.post('/v1/litta/order/settlement/list', params);
}
/**
 * 商家总数据看板
 * @param {*} params
 * @returns
 */
export async function tenantTotalData(params) {
  return $x.post('/athena/core/total', params);
}

/**
 * 商家周数据看板
 * @param {*} params
 * @returns
 */
export async function tenantWeekData(params) {
  return $x.post('/athena/core/week', params);
}

/**
 * 器械课程
 * @param {*} params
 * @returns
 */
export async function listTenantSpecialCourseCard(params) {
  return $x.post('/athena/listTenantSpecialCourseCard', params);
}

/**
 * 社区管理分页查询
 * @param {*} params
 * @returns
 */
export async function communityManagerPage(params) {
  return $x.post('/community/manager/communityManagerPage', params);
}
/**
 * 社区管理 操作文章状态 ID：m8w7wmg8
 * @param {*} params
 * @returns
 */
export async function operateStatus(params) {
  return $x.post('/community/manager/operateStatus', params);
}
/**
 * 社区管理 操作文章状态 ID：m8w7wmg8
 * @param {*} params
 * @returns
 */
export async function getArticleTextContent(params) {
  return $x.post('/community/manager/articleTextContent', params);
}
/**
 * 社区管理 操作文章状态 ID：m8w7wmg8
 * @param {*} params
 * @returns
 */
export async function savePushTask(params) {
  return $x.post('/community/manager/savePushTask', params);
}
/**
 * 社区管理 操作文章状态 ID：m8w7wmg8
 * @param {*} params
 * @returns
 */
export async function getPushTask(params) {
  return $x.post('/community/manager/getPushTask', params);
}
/**
 * 社区管理 操作文章状态 ID：m8w7wmg8
 * @param {*} params
 * @returns
 */
export async function deletePushTask(params) {
  return $x.post('/community/manager/deletePushTask', params);
}
/**
 * 操作风险状态
 * @param {*} params
 * @returns
 */
export async function operateRiskStatus(params) {
  return $x.post('/community/manager/operateRiskStatus', params);
}
/**
 * 搜索文章 ID：wXP4YMeX
 * @param {*} params
 * @returns
 */
export async function searchArticle(params) {
  return $x.post('/community/manager/searchArticle', params);
}
/**
 * 视频号id列表
 * @param {*} params
 * @returns
 */
export async function getListVideo(params) {
  return $x.post('/manual/push/task/listVideo', params);
}
/**
 * 手动推送任务列表 ID：BXgxNmxz
 * @param {*} params
 * @returns
 */
export async function listManualPushTask(params) {
  return $x.post('/manual/push/task/listManualPushTask', params);
}
/**
 * 保存手动推送任务 ID：a26MYQVz
 * @param {*} params
 * @returns
 */
export async function saveManualPushTask(params) {
  return $x.post('/manual/push/task/saveManualPushTask', params);
}
/**
 * 删除手动推送任务 ID：B2lYRDm8
 * @param {*} params
 * @returns
 */
export async function delManualPushTask(params) {
  return $x.post('/manual/push/task/delManualPushTask', params);
}
/**
 * gmvData
 * @param {*} params
 * @returns
 */
export async function queryGmvData(params) {
  return $x.post('/athena/gmvData', params);
}
/**
 * queryCoach
 * @param {*} params
 * @returns
 */
export async function queryCoach(params) {
  return $x.post('/athena/queryCoach', params);
}
/**
 * 发送预览手动推送任务
 * @param {*} params
 * @returns
 */
export async function previewManualPushTask(params) {
  return $x.post('/manual/push/task/previewManualPushTask', params);
}
/**
 * 审核手动推送任务
 * @param {*} params
 * @returns
 */
export async function reviewManualPushTask(params) {
  return $x.post('/manual/push/task/reviewManualPushTask', params);
}
/**
 * 新增公告
 * @param {*} params
 * @returns
 */
export async function addNotice(params) {
  return $x.post('/notice/add', params);
}
/**
 * 修改公告
 * @param {*} params
 * @returns
 */
export async function updateNotice(params) {
  return $x.post('/notice/update', params);
}
/**
 * 上下架公告
 * @param {*} params
 * @returns
 */
export async function onlineOrOutlineNotice(params) {
  return $x.post('/notice/onlineOrOutline', params);
}
/**
 * 公告列表
 * @param {*} params
 * @returns
 */
export async function getNoticeList(params) {
  return $x.post('/notice/manager', params);
}
/**
 * 看的见活动列表
 * @param {*} params
 * @returns
 */
export async function getVisiblePostList(params) {
  return $x.post('/post/list', params);
}
/**
 * 看的见活动列表
 * @param {*} params
 * @returns
 */
export async function postUpload(params) {
  return $x.post('/post/upload', params);
}
/**
 * 获取商家会员网络
 * @param {*} params
 * @returns
 */
export async function tenantUserNetwork(params) {
  return $x.post('/territory/distribution/tenantUserNetwork', params);
}
/**
 * 获取最近13个月的结算数据
 * @param {*} params
 * @returns
 */
export async function getSettlementData(params) {
  return $x.post('/athena/getSettlementData', params);
}
/**
 * 获取商家的POWER总结
 * @param {*} params
 * @returns
 */
export async function getTenantPowerSummary(params) {
  return $x.post('/athena/getTenantPowerSummary', params);
}
/**
 * 启动power分析
 * @param {*} params
 * @returns
 */
export async function tenantPowerSummaryStart(params) {
  return $x.post('/athena/tenantPowerSummaryStart', params);
}
/**
 * 商家洞察（二期）· 可选观察期列表 —— 三步读的第 ① 步，喂日期下拉框。
 * 入参：{ requestData: { tenantId } }
 * 出参：BaseResponse<List<TenantServicePeriodModel>>，
 *   data 按期次倒序（data[0] 即默认选中项），每项含
 *   periodStart / periodEnd（均为 yyyy-MM-dd，同一期闭区间）、dataGeneratedAt（可空）。
 * ⚠ 返回的 periodStart 集合同时是下面两个接口入参的合法取值集合，端上只应让用户选。
 * @param {*} params
 * @returns
 */
export async function getTenantServicePeriods(params) {
  return $x.post('/athena/tenantServicePeriods', params);
}
/**
 * 商家洞察（二期）· 店铺服务汇总 —— 三步读的第 ② 步（选中期次后拉首屏）。
 * 入参：{ requestData: { tenantId, periodStart? } }（periodStart 不传 = 最新一期）
 * 出参：BaseResponse<TenantServiceSummaryResponse>，data 含
 *   periodStart / periodEnd / periodStatus（1 已产出、0 未产出）
 *   / dataGeneratedAt / store（结构化计数，periodStatus=0 时为 null）
 *   / insights（≤2 条，已按 priority 升序，periodStatus=0 时为空）。
 * @param {*} params
 * @returns
 */
export async function getStoreServiceSummary(params) {
  return $x.post('/athena/storeServiceSummary', params);
}
/**
 * 商家洞察（二期）· 教练服务明细 —— 三步读的第 ③ 步（分页下钻）。
 * 入参：{ requestData: { tenantId, periodStart?, coachUserId? },
 *         page: { currentPage, pageSize } }
 *   —— 分页字段在 page 信封上，不在 requestData 里（与 /athena/queryCoach 同构）。
 *   pageSize 上限 200，超出会被判参数错误（不静默收窄）；不传时服务端默认 20。
 * 出参：PageResponse<List<TenantServiceCoachSummaryModel>>，
 *   data = 裸数组（每行自带 periodStart / periodEnd），page.count = 总行数。
 * ⚠ 本接口没有 periodStatus，「有没有数据」只能看 page.count；
 *   而 count = 0 时「该期跑过但没教练行」与「该期压根没产出」是两回事。
 * @param {*} params
 * @returns
 */
export async function getCoachServiceSummary(params) {
  return $x.post('/athena/coachServiceSummary', params);
}
